import React, { useState } from 'react';
import TreatmentCategoryIndex from './TreatmentCategoryIndex';
import TreatmentIndex from './TreatmentIndex';
import TreatmentSessionIndex from './TreatmentSessionIndex';
import CopyrightIcon from '@mui/icons-material/Copyright';

function TreatmentDashboard() {
    const [activeTab, setActiveTab] = useState('category');

    const tabStyle = (isActive) => ({
        padding: '6px 12px',
        fontSize: '12px',
        fontWeight: '600',
        cursor: 'pointer',
        border: 'none',
        background: isActive
            ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
            : 'transparent',
        color: isActive ? 'white' : '#6b7280',
        borderRadius: '12px',
        transition: 'all 0.3s ease',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        boxShadow: isActive ? '0 4px 12px rgba(102, 126, 234, 0.3)' : 'none',
    });

    return (
        <div style={{ padding: '16px', maxWidth: '100%' }}>
            {/* Tab Navigation */}
            <div style={{
                //background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                borderRadius: '16px',
                padding: '6px',
                marginBottom: '20px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                display: 'flex',
                gap: '6px',
                alignItems: 'center',
                marginTop: '-40px',
                height:'25px'
            }}>
                <button
                    onClick={() => setActiveTab('category')}
                    style={tabStyle(activeTab === 'category')}
                    onMouseEnter={(e) => {
                        if (activeTab !== 'category') {
                            e.target.style.background = '#f3f4f6';
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (activeTab !== 'category') {
                            e.target.style.background = 'transparent';
                        }
                    }}
                >
                    <span style={{ fontSize: '12px' }}>📁 Category</span>
                </button>

                <button
                    onClick={() => setActiveTab('treatment')}
                    style={tabStyle(activeTab === 'treatment')}
                    onMouseEnter={(e) => {
                        if (activeTab !== 'treatment') {
                            e.target.style.background = '#f3f4f6';
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (activeTab !== 'treatment') {
                            e.target.style.background = 'transparent';
                        }
                    }}
                >
                    <span style={{ fontSize: '12px' }}>💊 Treatment</span>
                </button>

                <button
                    onClick={() => setActiveTab('session')}
                    style={tabStyle(activeTab === 'session')}
                    onMouseEnter={(e) => {
                        if (activeTab !== 'session') {
                            e.target.style.background = '#f3f4f6';
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (activeTab !== 'session') {
                            e.target.style.background = 'transparent';
                        }
                    }}
                >
                    <span style={{ fontSize: '12px' }}>📋 Session</span>
                </button>
            </div>

            {/* Tab Content */}
            <div style={{
                background: 'white',
                borderRadius: '12px',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12)',
                overflow: 'hidden'
            }}>
                {activeTab === 'category' && <TreatmentCategoryIndex />}
                {activeTab === 'treatment' && <TreatmentIndex />}
                {activeTab === 'session' && <TreatmentSessionIndex />}
            </div>

            {/* Footer */}
            <div style={{
                position: 'fixed',
                bottom: '12px',
                right: '12px',
                display: 'flex',
                alignItems: 'center',
                gap: '0.3rem',
                padding: '0.3rem 0.65rem',
                background: 'rgba(255, 255, 255, 0.9)',
                borderRadius: '14px',
                boxShadow: '0 1px 6px rgba(0, 0, 0, 0.06)',
                fontFamily: 'serif',
                fontWeight: 'bold',
                color: '#2c3e50',
                fontSize: '0.7rem',
                backdropFilter: 'blur(10px)'
            }}>
                <CopyrightIcon />
                <b>EFFTABS SOLUTIONS LLP</b>
            </div>
        </div>
    );
}

export default TreatmentDashboard;
